import moment from "moment";
import { IColumn } from "../Types/gridDataProps";

export const createColumn = (columnName: string, accessor: string): Pick<IColumn, "name" | "accessor"> => {
  return {
    name: columnName, 
    accessor: accessor
  };
};

export const createColumnWithCustomClass = (columnName: string, accessor: string, customClass: {} | string): Pick<IColumn, "name" | "accessor" | "customClass"> => {
  return {
    name: columnName, 
    accessor: accessor,
    customClass: customClass
  };
};

export const createColumnWithRender = (columnName: string, accessor: string, renderFn: (obj: {value: any, row: any}) => JSX.Element): Pick<IColumn, "name" | "accessor" | "renderFunc"> => {
  return {
    name: columnName,
    accessor: (rowData: any) => {
      return {
        value: rowData?.[accessor],
        row: rowData
      }
    },
    renderFunc: renderFn
  };
};

export const createDateColumn = (columnName: string, accessor: string, customClass?: {} | string): Pick<IColumn, "name" | "accessor" | "customClass"> => {
  return {
    name: columnName,
    accessor: (rowData: any) => {
      return {
        value: rowData?.[accessor] ? moment(rowData[accessor]).format("YYYY-MM-DD") : "--"
      }
    },
    customClass: customClass
  };
}